module.exports = __webpack_public_path__ + "media/images/plans/plan-wedding-reception-22cf640a95d703e5c6fe2e8bcb3c38e5.png";